import { createRouter, createWebHistory } from 'vue-router'
import DisappearingProfile from '../views/DisappearingProfile.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: DisappearingProfile
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
